import {
  DeleteButton,
  DeleteButtonString,
  InfoPopup,
  Tooltip,
} from 'components';
import { useOutsideClick } from 'hooks';
import React, { ElementType, FC, useRef, useState } from 'react';

interface PopupButtonMessageProps {
  ButtonComponent?: ElementType;
  IconComponent?: ElementType;
  text?: string;
  popupHeaderText: string;
  popupMessageText?: string;
  popupButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => void;
  size?: 'sm' | 'md' | 'lg';
  tooltipText?: string;
  tooltipStyle?: { [key: string]: string | number };
}

const PopupButtonMessage: FC<PopupButtonMessageProps> = ({
  ButtonComponent,
  IconComponent,
  text,
  popupHeaderText,
  popupMessageText,
  popupButtonText,
  cancelButtonText,
  onConfirm = () => {},
  size,
  tooltipText,
  tooltipStyle,
}) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!open);
  const closePopup = () => setOpen(false);
  const wrapperRef = useRef(null);

  useOutsideClick(wrapperRef, closePopup);

  const handleConfirm = () => {
    onConfirm();
    closePopup();
  };

  const handleTypeButton = text ? (
    <DeleteButtonString label={text} onClick={toggleOpen} />
  ) : (
    <DeleteButton label={text} onClick={toggleOpen} />
  );

  const buttonContent = ButtonComponent ? (
    <ButtonComponent type="button" onClick={toggleOpen}>
      {IconComponent ? <IconComponent /> : null}
    </ButtonComponent>
  ) : (
    handleTypeButton
  );

  const wrappedButton = tooltipText ? (
    <Tooltip text={tooltipText} opacity="1" tooltipStyle={tooltipStyle}>
      {buttonContent}
    </Tooltip>
  ) : (
    buttonContent
  );

  return (
    <InfoPopup
      title={popupHeaderText}
      message={popupMessageText}
      type="warning"
      buttonText={popupButtonText}
      cancelButtonText={cancelButtonText}
      onButtonClick={handleConfirm}
      size={size}
    >
      {wrappedButton}
    </InfoPopup>
  );
};

export default PopupButtonMessage;
